import { Button, Paper, Stack } from "@mui/material";
import { format } from "date-fns";
import { useState } from "react";
import { DateRangePicker } from "materialui-daterange-picker";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { StyledBox } from "components/shared/filterSearchExport/transactionHeader/SettlementFSE";

export const FraudRulesFilterForm = ({
  values,
  onChange,
  onApply,
  onClear,
  close,
}) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  const handleChange = (event) => {
    const { name, value } = event.target;

    onChange((prev) => ({
      ...prev,
      [name]: value === "Show All" ? "" : value,
    }));
  };

  const handleDateChange = ({ startDate, endDate }) => {
    onChange((prev) => ({
      ...prev,
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply?.();
    close?.();
  };

  const handleClear = () => {
    onClear?.();
    close?.();
  };

  return (
    <Paper sx={{ p: 2 }}>
      <form onSubmit={handleSubmit} onChange={handleChange}>
        <StyledBox>
          <label>Dispute Status</label>
          <select name="disputeStatus" value={values.disputeStatus || ""}>
            <option value="">Show All</option>
            <option value="OPEN">OPEN</option>
            <option value="CLOSED">CLOSED</option>
          </select>
        </StyledBox>

        <StyledBox>
          <label>Admin Status</label>
          <select name="adminStatus" value={values.adminStatus || ""}>
            <option value="">Show All</option>
            <option value="INITIATED">Initiated</option>
            <option value="CUSTOMER_WON">Customer Won</option>
            <option value="MERCHANT_WON">Merchant Won</option>
          </select>
        </StyledBox>

        <StyledBox>
          <label>Merchant Status</label>
          <select name="merchantStatus" value={values.merchantStatus || ""}>
            <option value="">Show All</option>
            <option value="REJECTED">Rejected</option>
            <option value="ACCEPTED">Accepted</option>
            <option value="NO_RESPONSE">No Response</option>
          </select>
        </StyledBox>

        <StyledBox>
          <label>Resolution</label>
          <select name="resolution" value={values.resolution || ""}>
            <option value="">Show All</option>
            <option value="ChargeBack">Charge Back</option>
            <option value="Fraud">Fraud</option>
          </select>
        </StyledBox>

        <StyledBox sx={{ mb: 1 }}>
          <label>Date Range</label>
          <Paper elevation={1} sx={{ p: 2, width: "fit-content" }}>
            <Stack direction="row">
              {"From : "}
              <Button endIcon={<ArrowDropDownIcon />} onClick={toggle}>
                {values.startDate || "Select"}
              </Button>

              {"To : "}
              <Button endIcon={<ArrowDropDownIcon />} onClick={toggle}>
                {values.endDate || "Select"}
              </Button>
            </Stack>

            <DateRangePicker
              open={open}
              toggle={toggle}
              onChange={handleDateChange}
            />
          </Paper>
        </StyledBox>

        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={handleClear}>
            Clear
          </Button>

          <Button variant="contained" type="submit">
            Apply
          </Button>
        </Stack>
      </form>
    </Paper>
  );
};